var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.copyText()}}},[_c('p',{staticClass:"small text-muted m-0"},[(_vm.copied)?_c('span',{staticClass:"text-success"},[_vm._v("Copiado!")]):_c('i',{staticClass:"fa-solid fa-copy fa-lg"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }